import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CinejoyHomepageComponent } from './cinejoy-homepage/cinejoy-homepage.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CinejoyRoutingModule } from './cinejoy-routing.module';
import { AboutComponent } from './about/about.component';
import { GroupShareInfoPageComponent } from './group-share-info-page/group-share-info-page.component';
import { HowToTicketsComponent } from './how-to-tickets/how-to-tickets.component';
import { HowToGsComponent } from './how-to-gs/how-to-gs.component';
import {MatDialogModule} from '@angular/material/dialog';
import { JuryComponent } from './awards/jury/jury.component';
import { AwardsComponent } from './awards/awards/awards.component';
import { AllAwardsComponent } from './awards/all-awards/all-awards.component';
import { AwardService } from '../../core/services/awards/awards.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PassholdersWatchlistComponent } from './passholders-watchlist/passholders-watchlist.component';
import { ShowcaseModule } from '../showcase/showcase.module';
import { AllAccessComponent } from './all-access-pass/all-access-pass.component';



@NgModule({
  declarations: [
    CinejoyHomepageComponent,
    AboutComponent,
    GroupShareInfoPageComponent,
    HowToTicketsComponent,
    HowToGsComponent,
    JuryComponent,
    AwardsComponent,
    AllAwardsComponent,
    PassholdersWatchlistComponent,
    AllAccessComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FlexLayoutModule,
    CinejoyRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    ShowcaseModule
  ],
  providers:[
    AwardService,
    MatDialogModule
  ]
})
export class CinejoyModule { }
